/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Inject, Injectable } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslationService } from '@gh/core-mls';
import { ColDef } from 'ag-grid-community';
import { buildDateTimeColumn, ManualGridDefinition } from '@gh/core-ui-grid';
import { DateTimeTypes } from '@gh/common-shared';

@Injectable()
export class ScheduleCheckUsageGridDefinition extends ManualGridDefinition {

  constructor(@Inject(MAT_DIALOG_DATA) private dialogData: any,
              private translationService: TranslationService) {
    super();
  }

  buildColumnDefs(): ColDef[] {
    return [
        { field: 'taskName', headerName: this.translationService.get('lbl_task_name'), width: 400 },
        { field: 'scheduleFor', headerName: this.translationService.get('lbl_schedule_for'), width: 200 },
        { field: 'startDate',
          ...buildDateTimeColumn(DateTimeTypes.ShortDate),
          headerName: this.translationService.get('lbl_start_date'),
          width: 200,
        },
        { field: 'endDate',
          ...buildDateTimeColumn(DateTimeTypes.ShortDate),
          headerName: this.translationService.get('lbl_end_date'),
          width: 200,
        },
      ];
  }
}
